import { Constants } from "@core/Utils/Constants";
import { IMAXAServerMessage, TransactionSource } from "@core/Logic/Links/IMAXA/IMAXAProtocol";
import { Phase } from '@core/Logic/Logic';
import { Client } from "@core/Client";

export enum VirtualWheelState {
    IDLE,              //wheel idly spins
    ACTIVE_WAITING,    //wheel idly spins, sends placed bets , closes bets and waits for server response -> after getting a result, waits for animation to align properly and goes to next state
    PLAYING_DROP_ANIM, //ball is ejected and plays its animation untill it drops into the dish 
    INNER_SPIN         //ball is idle spinning on number in inner plate, we also display zoom image on the side, trigger animation for win/number drop
}
const msPerFrame_Fast = 50;
const msPerFrame_Slow = 150;
const wheelFrame = 360 / 62;
const fieldAngle = 360 / 37;
const fieldAngleDoubleZero = 360 / 38;

export class VirtualWheelDisplay extends Phaser.GameObjects.Container {

    public currentWheelState: VirtualWheelState = VirtualWheelState.IDLE;
    public hasResult: boolean = false;
    public forced: boolean = false;

    public spinButton: Phaser.GameObjects.Sprite;
    public skipButton: Phaser.GameObjects.Sprite;

    private firstBalanceUpdate: boolean = false;
    private balanceCache: any;
    private gameEndCache: any;

    private background: Phaser.GameObjects.Graphics;
    private innerWheel: Phaser.GameObjects.Sprite;
    private outerWheel: Phaser.GameObjects.Sprite;
    private ball: Phaser.GameObjects.Sprite;
    private zoomDisplay: Phaser.GameObjects.Sprite;

    private dropAnimationKeys: string[] = ["balldropanim1", "balldropanim2", "balldropanim3", "balldropanim4"];//available random drop animations
    private dropAnimationEndAngle: number[] = [175.13, 19.45, 330.81, 330.81];
    private dropAnimationRandomAngle: number;
    private selectedDropAnimationIndex: number = 0;

    private hideButtonTween: Phaser.Tweens.Tween;
    private showBackgroundTween: Phaser.Tweens.Tween;
    private zoomTween: Phaser.Tweens.Tween;
    private zoomTween_ToY: number;
    private zoomTween_FromY: number;
    private zoomTween_FromX: number;
    private zoomTween_FromScale: number = 1;
    private zoomTween_ToScale: number = 1;
    private zoomFactor: number = 2;
    private speedUp: boolean = false;
    private spinSpeed: number = msPerFrame_Slow;
    private resetTimeout: any;

    private result: number = -1;

    private portraitMode: boolean = false;

    private localGameId: number = 1;

    constructor(scene: Phaser.Scene, positionX, positionY, size) {
        super(scene);

        this.background = this.scene.add.graphics();
        this.background.fillStyle(0x000000, 0.65);
        this.background.visible = false;
        this.background.alpha = 0;

        this.outerWheel = this.scene.add.sprite(positionX + size / 2, positionY + size / 2, Constants.SPRITESHEET_VIRTUAL_WHEEL, "wheel_bottom.png");
        this.outerWheel.setOrigin(0.5);
        this.outerWheel.setDisplaySize(size, size);

        this.innerWheel = this.scene.add.sprite(positionX + size / 2, positionY + size / 2, Constants.SPRITESHEET_VIRTUAL_WHEEL, Client.logic.IsDoubleZero() ? "wheel_top_double_zero.png" : "wheel_top.png");
        this.innerWheel.setOrigin(0.5);
        this.innerWheel.setDisplaySize(size, size);

        this.ball = this.scene.add.sprite(positionX, positionY, "balldropanim1");
        this.ball.play("ballendanim");
        this.ball.anims.skipMissedFrames = true;
        this.ball.anims.msPerFrame = msPerFrame_Fast;
        this.ball.setOrigin(0.5);
        this.ball.setDisplaySize(size, size);
        this.ball.visible = false;

        this.zoomDisplay = this.scene.add.sprite(positionX, positionY, Constants.SPRITESHEET_BALL_DROPPED_ZOOM, "0.png");
        this.zoomDisplay.setOrigin(0);
        this.zoomDisplay.setDisplaySize(size / 4, size / 4);
        this.zoomDisplay.visible = false;

        this.spinButton = this.scene.add.sprite(positionX, positionY, Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_Normal.png");
        this.spinButton.setDisplaySize(size / 5, size / 5);
        this.toggleSpinButton(false)
        this.spinButton.on("pointerdown", () => {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_Clicked.png")
            this.Start();
        }, this);
        this.spinButton.on("pointerup", () => {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_MouseOver.png")
        }, this);
        this.spinButton.on("pointerover", (e) => {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_MouseOver.png")
        }, this);
        this.spinButton.on("pointerout", (e) => {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_Normal.png")
        }, this);

        this.skipButton = this.scene.add.sprite(positionX, positionY, Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_Normal.png");
        this.skipButton.setInteractive();
        this.skipButton.setDisplaySize(size / 5, size / 5);
        this.skipButton.on("pointerdown", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_Clicked.png")
            this.Skip();
        }, this);
        this.skipButton.on("pointerup", (pointer: Phaser.Input.Pointer, localX: number, localY: number, event: Phaser.Types.Input.EventData) => {
            event.stopPropagation();
            this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_MouseOver.png")
        }, this);
        this.skipButton.on("pointerover", (e) => {
            this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_MouseOver.png")
        }, this);
        this.skipButton.on("pointerout", (e) => {
            this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_Normal.png")
        }, this);
        this.toggleSkipButton(false);
        this.skipButton.visible = false;

        this.scene.game.events.on(Constants.EVENTS.VIRTUAL_WHEEL_RESPONSE, (_ok: boolean, msg: IMAXAServerMessage) => { this.ResultResponse(_ok, msg) });
        this.scene.game.events.on(Constants.EVENTS.VIRTUAL_WHEEL_TOGGLE_SPIN_BUTTON, (enabled: boolean) => this.toggleSpinButton(enabled));
        this.scene.game.events.on(Constants.EVENTS.VIRTUAL_DELAY_BALANCE, (data: any) => this.HandleDelayedBalance(data));
        this.scene.game.events.on(Constants.EVENTS.VIRTUAL_GAME_END, (data: any) => this.HandleDelayedGameEnd(data));
        this.scene.game.events.on("hideVideo", () => { this.Visibility(false) });
        this.scene.game.events.on("showVideo", () => { this.Visibility(true) });

		Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 1.0, true);
        Client.logic.OnChangePhase(Phase.BETS_OPEN_STATE);

        //makes them render over everything else
        this.background.setDepth(999);
        this.outerWheel.setDepth(1000);
        this.innerWheel.setDepth(1001);
        this.ball.setDepth(1002);
        this.spinButton.setDepth(1003);
        this.skipButton.setDepth(1004);
        this.zoomDisplay.setDepth(1005);

        //Zoom in and out tweens--------------------
        this.zoomTween_FromY = (positionY + size / 2);
        this.zoomTween_FromX = (positionX + size / 2);
        this.zoomTween_ToY = this.zoomTween_FromY * this.zoomFactor;
        this.zoomTween_FromScale = this.innerWheel.scale;
        this.zoomTween_ToScale = this.zoomTween_FromScale * this.zoomFactor;
        this.zoomTween = this.scene.tweens.add({
            targets: [this.ball, this.innerWheel, this.outerWheel],
            alpha: { from: 1, to: 1 },
            scale: { from: this.zoomTween_FromScale, to: this.zoomTween_ToScale },
            y: { from: this.zoomTween_FromY, to: this.zoomTween_ToY },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: true,
            onYoyo: () => this.zoomTweenOnYoyo()
        });
        this.zoomTween.stop();

        this.showBackgroundTween = this.scene.tweens.add({
            targets: [this.background],
            alpha: { from: 0, to: 1 },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: true,
            onYoyo: () => this.backgroundTweenOnYoyo()
        });
        this.showBackgroundTween.pause();

        this.hideButtonTween = this.scene.tweens.add({
            targets: [this.spinButton],
            alpha: { from: 1, to: 0 },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: true,
            onYoyo: () => this.hideButtonTweenOnYoyo()
        });
        this.hideButtonTween.stop();
        //------------------------------------------

        Client.logic.VirtualWheelClearBets();
        Client.logic.OnUpdateGameId(this.localGameId);

        this.scene.events.on('update', function (time, delta) {

            if (this.speedUp) {
                if (this.spinSpeed > msPerFrame_Fast)
                    this.spinSpeed -= 2;

                else if (this.spinSpeed < msPerFrame_Fast)
                    this.spinSpeed = msPerFrame_Fast;
            }
            else {
                if (this.spinSpeed < msPerFrame_Slow)
                    this.spinSpeed += 1;

                else if (this.spinSpeed > msPerFrame_Slow)
                    this.spinSpeed = msPerFrame_Slow;
            }

            this.innerWheel.angle += wheelFrame * (delta / this.spinSpeed)
            let singleZeroOrDoubleZero = Client.logic.IsDoubleZero() ? Constants.DOUBLE_ZERO_NUMBERS : Constants.SINGLE_ZERO_NUMBERS

            if (this.currentWheelState == VirtualWheelState.ACTIVE_WAITING && this.hasResult && this.spinSpeed == msPerFrame_Fast) {
                var whereIsResultFieldNow = ((this.innerWheel.angle + 360) + (singleZeroOrDoubleZero.indexOf(this.result) * (Client.logic.IsDoubleZero() ? fieldAngleDoubleZero : fieldAngle))) % 360;
                var whereWillTheBallDrop = (this.dropAnimationEndAngle[this.selectedDropAnimationIndex] + this.dropAnimationRandomAngle) % 360;
                if (whereWillTheBallDrop < ((whereIsResultFieldNow + (Client.logic.IsDoubleZero() ? fieldAngleDoubleZero : fieldAngle) / 2) % 360) && whereWillTheBallDrop > ((whereIsResultFieldNow - (Client.logic.IsDoubleZero() ? fieldAngleDoubleZero : fieldAngle) / 2) % 360)) {
                    console.log("VIRTUAL BALL EJECTED");
                    this.currentWheelState = VirtualWheelState.PLAYING_DROP_ANIM;//ball is ejected phase

                    this.ball.angle = this.dropAnimationRandomAngle;
                    if (this.innerWheel.visible)
                        this.ball.visible = true;
                    this.ball.play(this.dropAnimationKeys[this.selectedDropAnimationIndex]);
                    this.ball.on('animationcomplete', this.DropAnimCompleted, this);//once this animation is finished, since it is timed it should end up in the right pocket and we now go to final step

                    this.background.visible = true;
                    this.background.alpha = 0;

                    //zoom in on eject
                    this.zoomTween.removeAllListeners();
                    this.scene.tweens.remove(this.zoomTween);
                    this.zoomTween = null;
                    this.zoomTween = this.scene.tweens.add({
                        targets: [this.ball, this.innerWheel, this.outerWheel],
                        alpha: { from: 1, to: 1 },
                        scale: { from: this.zoomTween_FromScale, to: this.zoomTween_ToScale },
                        y: { from: this.zoomTween_FromY, to: this.zoomTween_ToY },
                        ease: 'Linear',
                        duration: 250,
                        repeat: 0,
                        yoyo: true,
                        onYoyo: () => this.zoomTweenOnYoyo()
                    });
                    this.hideButtonTween.play();

                    this.showBackgroundTween.removeAllListeners();
                    this.scene.tweens.remove(this.showBackgroundTween);
                    this.showBackgroundTween = null;
                    this.showBackgroundTween = this.scene.tweens.add({
                        targets: [this.background],
                        alpha: { from: 0, to: 1 },
                        ease: 'Linear',
                        duration: 250,
                        repeat: 0,
                        yoyo: true,
                        onYoyo: () => this.backgroundTweenOnYoyo()
                    });
                }
            }
            else if (this.currentWheelState == VirtualWheelState.INNER_SPIN || (this.currentWheelState == VirtualWheelState.IDLE && this.ball.visible))
                this.ball.angle = this.innerWheel.angle + (singleZeroOrDoubleZero.indexOf(this.result) * (Client.logic.IsDoubleZero() ? fieldAngleDoubleZero : fieldAngle));

        }, this);
    }

    public Visibility(visible) {
        if (visible) {
            this.outerWheel.visible = true;
            this.innerWheel.visible = true;
            if (this.currentWheelState == VirtualWheelState.IDLE) {
                this.spinButton.visible = true;
            }
            if (this.currentWheelState == VirtualWheelState.INNER_SPIN || this.currentWheelState == VirtualWheelState.PLAYING_DROP_ANIM) {
                this.ball.visible = true;
                if (this.currentWheelState == VirtualWheelState.INNER_SPIN)
                    this.zoomDisplay.visible = true;
            }
        }
        else {
            this.outerWheel.visible = false;
            this.innerWheel.visible = false;
            this.zoomDisplay.visible = false;
            this.ball.visible = false;
            this.spinButton.visible = false;
        }
    }

    public Skip() {
        if (this.hasResult && this.currentWheelState != VirtualWheelState.IDLE) {
            this.forced = true;

            if (this.zoomTween.isPlaying() || this.zoomTween.progress > 0) {
                this.zoomTween.seek(1);
            }
            if (this.hideButtonTween.isPlaying() || this.hideButtonTween.progress > 0) {
                this.hideButtonTween.seek(1);
            }
            if (this.showBackgroundTween.isPlaying() || this.showBackgroundTween.progress > 0) {
                this.showBackgroundTween.seek(1);
            }

            this.innerWheel.setScale(this.zoomTween_FromScale);
            this.outerWheel.setScale(this.zoomTween_FromScale);
            this.ball.setScale(this.zoomTween_FromScale);

            this.outerWheel.x = this.zoomTween_FromX;
            this.outerWheel.y = this.zoomTween_FromY;

            this.innerWheel.x = this.outerWheel.x;
            this.innerWheel.y = this.outerWheel.y;

            this.ball.x = this.outerWheel.x;
            this.ball.y = this.outerWheel.y;

            this.spinButton.alpha = 1;
            this.spinButton.visible = true;

            this.innerWheel.visible = true;
            this.outerWheel.visible = true;

            this.background.visible = false;
            this.background.alpha = 0;

            this.DropAnimCompleted("", 1);

            this.forced = false;
        }
    }

    public UpdatePosition(positionX, positionY, size, zoomSize, portraitMode, staticWidth, staticHeight): void {
        this.zoomTween_FromY = (positionY + size / 2);
        this.zoomTween_FromX = (positionX + size / 2);

        var minWheelSize = size;
        if (size < (zoomSize * 5)) {
            minWheelSize = zoomSize * 5;
            this.zoomTween_FromY -= (minWheelSize - size) / 2;
        }

        this.portraitMode = portraitMode;
        this.zoomFactor = Math.min(staticWidth / minWheelSize, staticHeight / minWheelSize);

        this.outerWheel.setPosition(this.zoomTween_FromX, this.zoomTween_FromY);
        this.outerWheel.setDisplaySize(minWheelSize + 15, minWheelSize + 15);

        this.innerWheel.setPosition(this.outerWheel.x, this.outerWheel.y);
        this.innerWheel.setDisplaySize(minWheelSize + 15, minWheelSize + 15);

        this.ball.setPosition(this.outerWheel.x, this.outerWheel.y);
        this.ball.setDisplaySize(minWheelSize + 15, minWheelSize + 15);

        var zoomMaxSize = Math.max(zoomSize * 1.3, size / 3);
        this.zoomDisplay.setPosition(positionX + (zoomMaxSize / 4) - ((staticWidth / size) * (zoomMaxSize / 8)), positionY + 3);
        this.zoomDisplay.setDisplaySize(zoomMaxSize, zoomMaxSize);

        var spinButtonSize = zoomSize * 1.2;
        this.spinButton.setPosition(positionX + size - (spinButtonSize / 2) + ((staticWidth / size) * (spinButtonSize / 8)), positionY + size - (spinButtonSize / 2) + 8);
        this.spinButton.setDisplaySize(spinButtonSize, spinButtonSize);

        if (portraitMode)
            this.skipButton.setPosition(staticWidth - zoomMaxSize, - zoomMaxSize);
        else
            this.skipButton.setPosition(staticWidth - zoomMaxSize, staticHeight - zoomMaxSize);

        this.skipButton.setDisplaySize(zoomMaxSize * 2, zoomMaxSize * 2);

        //Tween update
        this.zoomTween_FromScale = this.outerWheel.scale;
        this.zoomTween_ToScale = this.zoomTween_FromScale * this.zoomFactor;

        if (this.portraitMode) {
            this.zoomTween_ToY = -(staticHeight / 2);
        } else {
            this.zoomTween_ToY = (positionY + minWheelSize / 2) * this.zoomFactor;
        }

        this.zoomTween.removeAllListeners();
        this.scene.tweens.remove(this.zoomTween);
        this.zoomTween = null;
        this.zoomTween = this.scene.tweens.add({
            targets: [this.ball, this.innerWheel, this.outerWheel],
            alpha: { from: 1, to: 1 },
            scale: { from: this.zoomTween_FromScale, to: this.zoomTween_ToScale },
            y: { from: this.zoomTween_FromY, to: this.zoomTween_ToY },
            ease: 'Linear',
            duration: 250,
            repeat: 0,
            yoyo: true,
            onYoyo: () => this.zoomTweenOnYoyo()
        });
        this.zoomTween.pause();

        this.background.clear();
        this.background.fillStyle(0x000000, 0.65);
        if (this.portraitMode)
            this.background.fillRect(0, -staticHeight, staticWidth, staticHeight);
        else
            this.background.fillRect(0, 0, staticWidth, staticHeight);
    }

    private zoomTweenOnYoyo() {
        if (this.currentWheelState != VirtualWheelState.IDLE && !this.forced)
            this.zoomTween.pause();
    }

    private backgroundTweenOnYoyo() {
        if (this.currentWheelState != VirtualWheelState.IDLE && !this.forced)
            this.showBackgroundTween.pause();
    }

    private hideButtonTweenOnYoyo() {
        if (this.currentWheelState != VirtualWheelState.IDLE && !this.forced)
            this.hideButtonTween.pause();
    }

    //if drop animation has ended or it was force skipped to end
    DropAnimCompleted(animation, frame): void {
        try { this.ball.off('animationcomplete'); } catch (e) { }//unsubscribe from animation end event if we made it that far
        this.currentWheelState = VirtualWheelState.INNER_SPIN;//final stage is spinning ball on plate

        let doubleZeroTexturePrefix = ""
        if (Client.logic.IsDoubleZero()) doubleZeroTexturePrefix = "double_zero_"

        //var angle = ((this.innerWheel.anims.currentFrame.index - 1) + Constants.SINGLE_ZERO_NUMBERS.indexOf(this.result) * (62 / 37));
        this.ball.play("ballendanim", false);
        if (this.innerWheel.visible)
            this.ball.visible = true;
        this.ball.anims.pause();
        this.ball.anims.setCurrentFrame(this.ball.anims.currentAnim.frames[0]);

        if (this.forced) {
            this.speedUp = false;
            Client.logic.OnChangePhase(Phase.READING_WIN_NUMBER_STATE);
            Client.logic.winNumberReceived(this.result);//send win number to game - we already knew it but we had to put on a show (unless skipped)
            if (this.balanceCache)
                Client.logic.handleBalanceUpdateEvent(this.balanceCache);//update balance
            if (this.gameEndCache)
                Client.logic.OnGameEndEvent(this.gameEndCache);

            //also show the zoomed in picture of the number
            this.zoomDisplay.setTexture(Constants.SPRITESHEET_BALL_DROPPED_ZOOM, doubleZeroTexturePrefix + this.result + ".png");
            this.zoomDisplay.visible = true;

            this.toggleSkipButton(false);
            this.skipButton.visible = false;

            if (this.zoomTween.progress > 0) {
                this.zoomTween.seek(1);
                this.zoomTween.pause();
            }
            if (this.hideButtonTween.progress > 0) {
                this.hideButtonTween.seek(1);
            }
            if (this.showBackgroundTween.progress > 0) {
                this.showBackgroundTween.seek(1);
                this.showBackgroundTween.pause();
            }

            this.resetTimeout = setTimeout(function () {
                this.Reset();
            }.bind(this), 3700);
        }
        else {
            //on timeout reset the entire thing if its a normal non rushed end
            setTimeout(function () {
                if (this.forced)
                    return;

                this.toggleSkipButton(false);
                this.skipButton.visible = false;

                if (this.zoomTween.isPaused())
                    this.zoomTween.resume();

                if (this.hideButtonTween.isPaused())
                    this.hideButtonTween.resume();

                if (this.showBackgroundTween.isPaused())
                    this.showBackgroundTween.resume();

                setTimeout(function () {
                    if (this.forced)
                        return;
                    this.speedUp = false;
                    Client.logic.OnChangePhase(Phase.READING_WIN_NUMBER_STATE);
                    Client.logic.winNumberReceived(this.result);//send win number to game - we already knew it but we had to put on a show (unless skipped)
                    if (this.balanceCache)
                        Client.logic.handleBalanceUpdateEvent(this.balanceCache);//update balance
                    if (this.gameEndCache)
                        Client.logic.OnGameEndEvent(this.gameEndCache);

                    //also show the zoomed in picture of the number
                    this.zoomDisplay.setTexture(Constants.SPRITESHEET_BALL_DROPPED_ZOOM, doubleZeroTexturePrefix + this.result + ".png");
                    this.zoomDisplay.visible = true;

                    this.currentLocalGameId = this.localGameId;//stored here, to prevent double resets

                    this.resetTimeout = setTimeout(function () {
                        if (this.forced)
                            return;
                        this.Reset();
                    }.bind(this), 3700);
                }.bind(this), 500);
            }.bind(this), 500);
        }
    }

    ResultResponse(_ok: boolean, msg: IMAXAServerMessage): void {
        if (this.hasResult)
            return;

        if (_ok) {
            this.result = msg.payload.winNumber;
            this.hasResult = true;
            this.toggleSkipButton(true);
            this.skipButton.visible = true;

            Client.remote.RemoteActionsHaveChanged();
        } else {
            this.Reset();
        }
    }

    Start() {
        if (this.currentWheelState == VirtualWheelState.IDLE && Client.logic.BetSum > 0) {//if we have bets, and did not start yet, start
            console.log("VIRTUAL START");

            if (Client.logic.Phase != Phase.SHOWING_HISTORY_REPLAY)
                Client.game.events.emit(Constants.EVENTS.UPDATE_MAIN_TEXT, [""]);

            this.result = -1;
            this.speedUp = true;

            this.ball.visible = false;
            this.ball.angle = 0;

            this.zoomDisplay.visible = false;

            if (this.zoomDisplay.visible)
                this.zoomDisplay.visible = false;

            this.currentWheelState = VirtualWheelState.ACTIVE_WAITING;//virtual wheel is in wait mode - appears idle but is waiting for server response and anim sync

            Client.logic.sendBets(true);//send bets to server right away - success response also gives us result -> "ResultResponse"
            Client.logic.OnChangePhase(Phase.WAITING_WIN_NUMBER_STATE);//close bets
            Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 0.0 , true);

            this.selectedDropAnimationIndex = Math.floor(Math.random() * this.dropAnimationKeys.length);//randomly select a drop animation
            this.dropAnimationRandomAngle = Math.random() * 360;//add some randomness to drop animation angles

            this.toggleSpinButton(false)

            if (Constants.DEVELOPER_MODE)//if dev - randomly pick numbers
            {
                this.hasResult = true;
                this.result = Math.floor(Math.random() * 37);
                this.toggleSkipButton(true);
                this.skipButton.visible = true;
                console.log("VirtualWheel -> RNG SELECTED : " + this.result + ", ANIM SELECTED: " + this.dropAnimationKeys[this.selectedDropAnimationIndex]);
                console.log("VIRTUAL GOT RESULT");
                /*
                setTimeout(function () {
                    this.Skip();
                }.bind(this), 6500);
                */
            }

            Client.remote.RemoteActionsHaveChanged();
        }
    }

    Reset() {
        clearTimeout(this.resetTimeout);

        if (this.hasResult) {
            try { this.ball.off('animationcomplete'); } catch (e) { }//unsubscribe from animation end event if we made it that far
        }

        this.hasResult = false;
        this.speedUp = false;

        Client.logic.VirtualWheelClearBets();
        this.balanceCache = null;
        this.gameEndCache = null;
        this.firstBalanceUpdate = false;
        this.currentWheelState = VirtualWheelState.IDLE;

        //yoyo those animations back if they were skipped
        if (this.zoomTween.isPaused())
            this.zoomTween.resume();

        if (this.hideButtonTween.isPaused())
            this.hideButtonTween.resume();

        if (this.showBackgroundTween.isPaused())
            this.showBackgroundTween.resume();


        this.innerWheel.x = this.zoomTween_FromX;
        this.innerWheel.y = this.zoomTween_FromY;

        this.outerWheel.x = this.innerWheel.x;
        this.outerWheel.y = this.innerWheel.y;

        this.ball.anims.stop();
        this.ball.x = this.innerWheel.x;
        this.ball.y = this.innerWheel.y;

        this.background.visible = false;
        this.background.alpha = 0;

        Client.logic.winNumberReceived(-1);
        Client.game.events.emit(Constants.EVENTS.PROGRESSBAR, 1.0 , true);
        Client.logic.OnChangePhase(Phase.BETS_OPEN_STATE);

        this.localGameId++;
        Client.logic.OnUpdateGameId(this.localGameId);

        this.forced = false;
        this.toggleSkipButton(false);
        this.skipButton.visible = false;

        Client.remote.RemoteActionsHaveChanged();
    }

    Destroy(): void {
        this.innerWheel.destroy();
        this.ball.destroy();
        this.zoomDisplay.destroy();
        this.removeAll(true);
    }

    public HandleDelayedBalance(data): void {
        if (data.source != TransactionSource.Game || !this.firstBalanceUpdate || this.currentWheelState == VirtualWheelState.IDLE || this.currentWheelState == VirtualWheelState.INNER_SPIN) {
            Client.logic.handleBalanceUpdateEvent(data);
            this.firstBalanceUpdate = true;
        }
        else
            this.balanceCache = data;
    }

    public HandleDelayedGameEnd(data): void {
        this.gameEndCache = data;
    }

    private toggleSpinButton(enabled: boolean): void {
        if (enabled) {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_Normal.png");
            this.spinButton.setInteractive();
            this.zoomDisplay.visible = false;
            this.ball.visible = false;
            if (Client.logic.autoplay) {
                setTimeout(() => {
                    this.Start();
                }, 1000);
            }
            return
        }
        else {
            this.spinButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "SpinButton_Disabled.png");
            this.spinButton.removeInteractive();
        }
        Client.remote.RemoteActionsHaveChanged();
    }

    private toggleSkipButton(enabled: boolean): void {
        if (enabled) {
            this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_Normal.png");
            this.skipButton.setInteractive();
            if (Client.logic.autoplay) {
                setTimeout(() => {
                    this.Skip();
                }, 1000);
            }
            return
        } else {
            //this.skipButton.setTexture(Constants.SPRITESHEET_VIRTUAL_WHEEL, "FastForwardButton_Disabled.png")
            this.skipButton.removeInteractive()
        }
        Client.remote.RemoteActionsHaveChanged();
    }
}
